import { ButtonBase, Grid2, Typography, useTheme } from '@mui/material';
import LanguageSharpIcon from '@mui/icons-material/LanguageSharp';
import React from 'react';
import { ICountryInfo } from '../utils/languageHelper';

interface LanguageProps {
  openLanguageMenu: (event: React.MouseEvent<HTMLElement>) => void;
  displayedLanguageInfo: ICountryInfo;
}

const Language: React.FC<LanguageProps> = ({
  openLanguageMenu,
  displayedLanguageInfo,
}) => {
  const theme = useTheme();

  const styles = {
    languageBtn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: {
        sx: 'flex-end',
        sm: 'center',
      },
      height: '100%',
      gap: '.5rem',
      ml: 'auto',
    },
  };

  return (
    <Grid2 sx={{ display: 'block' }} size={{ xs: 2, xl: 1.5 }}>
      <ButtonBase
        data-cy="language-toggle-button"
        id="LanguageToggler"
        onClick={openLanguageMenu}
        sx={styles.languageBtn}
      >
        <LanguageSharpIcon style={{ color: theme.palette.secondary.dark }} />
        <Typography color={theme.palette.secondary.dark} fontWeight={600}>
          {displayedLanguageInfo?.displayName}
        </Typography>
      </ButtonBase>
    </Grid2>
  );
};

export default Language;
